import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";

const ErrorMessage = ({ message, subMessage }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        width: "50%",
        height: "20rem",
        margin: "12rem auto 0 auto",
        padding: "0 2rem 2rem 2rem",
        borderRadius: "10px",
        backgroundColor: "#c50b0b",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          fontSize: "3rem",
          color: "#FFFFFF",
          textAlign: "center",
        }}
      >
        {t(message)}
      </Box>
      <Box
        sx={{
          fontSize: "2.53rem",
          color: "#FFFFFF",
          textAlign: "center",
          marginTop: "-1rem",
        }}
      >
        {t(subMessage)}
      </Box>
    </Box>
  );
};
export default ErrorMessage;
